import { render, staticRenderFns } from "./verifyLiveOrder.vue?vue&type=template&id=134bc07e&scoped=true"
import script from "./verifyLiveOrder.vue?vue&type=script&lang=js"
export * from "./verifyLiveOrder.vue?vue&type=script&lang=js"
import style0 from "./verifyLiveOrder.vue?vue&type=style&index=0&id=134bc07e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134bc07e",
  null
  
)

export default component.exports